import { Injectable } from '@angular/core';
import { MicrophoneService } from 'src/app/services/audio/microphone/microphone.service';
import { ISectionPresenter } from '../../../models/section-presenter';
import { CommonService } from '../../../../services/common/common.service';
import { LocalStorageKey } from 'src/app/enums/local-storage-key.enum';
import { LoggerService } from 'src/app/services/logger/logger.service';
@Injectable({
	providedIn: 'root',
})
export class MicrophoneSettingsSection implements ISectionPresenter {
	constructor(private microphoneSettings: MicrophoneService, private logger: LoggerService) {}

	public async isVisible(): Promise<boolean> {
		this.logger.info('AudioPage - MicrophoneSettingsSection - isVisible - Start');
		const isFeatureToggleEnabled = this.microphoneSettings.getFeatureToggle();
		if(!isFeatureToggleEnabled){
			this.logger.info('AudioPage - MicrophoneSettingsSection - getFeatureToggle - isVisible - end', false);
			return Promise.resolve(false);
		}
		try {
			const hasCapability = await this.microphoneSettings.getCapability();
			const isVisible = hasCapability;
			this.logger.info('AudioPage - MicrophoneSettingsSection - isVisible - end', isVisible);
			return Promise.resolve(isVisible);
		} catch (error) {
			this.logger.error(
				'AudioPage - MicrophoneSettingsSection - getCapability - error',
				error
			);
		}
		return undefined;
	}
}
